/**
 * Login Page
 * 
 * Authentication page using Clerk SignIn component.
 */

import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { motion } from 'framer-motion';

function LoginPage() {
    return (
        <div className="min-h-[calc(100vh-64px)] flex items-center justify-center bg-charcoal py-12 px-4 relative overflow-hidden">
            {/* Ambient Background Glows */}
            <div className="absolute -top-48 -right-48 w-96 h-96 bg-wine-700/15 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute -bottom-48 -left-48 w-96 h-96 bg-[#C4A35A]/8 rounded-full blur-3xl pointer-events-none" />

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="relative z-10"
            >
                <SignIn
                    routing="path"
                    path="/login"
                    signUpUrl="/register"
                    forceRedirectUrl="/profile"
                />
            </motion.div>
        </div>
    );
}

export default LoginPage;
